import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';

const stats = [
  { value: "5000+", label: "累计独家爆料" },
  { value: "100万+", label: "日活跃用户" },
  { value: "99.7%", label: "内容真实率" },
  { value: "200+", label: "合作信源渠道" },
];

const milestones = [
  { year: "2020", event: "51吃瓜爆料网正式成立，开启娱乐资讯新纪元" },
  { year: "2021", event: "用户突破10万，建立首个独家信源网络" },
  { year: "2022", event: "日活突破50万，成为行业头部吃瓜平台" },
  { year: "2023", event: "发布独家爆料超2000篇，多次引领全网话题" },
  { year: "2024", event: "完成品牌升级，覆盖六大内容品类" },
  { year: "2025", event: "日活突破100万，成为全网最大的免费吃瓜社区" },
  { year: "2026", event: "持续深耕内容质量，引领行业标准" },
];

export default function AboutPage() {
  const orgJsonLd = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "51吃瓜爆料网",
    "alternateName": "吃瓜爆料",
    "url": "https://www.chigua51.com",
    "description": "全网最活跃的免费吃瓜社区，专注于网红黑料大全、明星翻车与热点事件深度揭秘",
    "foundingDate": "2020",
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "customer service",
      "email": "tips@chigua51.com",
    },
    "sameAs": [
      "https://weibo.com/chigua51",
      "https://www.zhihu.com/org/chigua51",
    ],
  };

  const aboutJsonLd = {
    "@context": "https://schema.org",
    "@type": "AboutPage",
    "name": "关于我们 - 51吃瓜爆料网",
    "description": "51吃瓜爆料网成立于2020年，是全网最活跃的免费吃瓜社区。专注于网红黑料大全、明星翻车与热点事件深度揭秘。",
    "url": "https://www.chigua51.com/about",
  };

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(orgJsonLd) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(aboutJsonLd) }} />
      <Navbar />
      <main>
        <section className="relative h-64 md:h-80 overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Dark%20moody%20newsroom%20atmosphere%20with%20dramatic%20lighting%20editorial%20team%20in%20silhouette%20cinematic%20composition%20warm%20amber%20accent%20high%20contrast%20documentary%20style&width=1920&height=600&seq=about-hero&orientation=landscape"
            alt="关于51吃瓜爆料网"
            className="w-full h-full object-cover object-top"
            title="关于51吃瓜爆料网"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>
          <div className="absolute inset-0 flex items-center">
            <div className="w-full px-4 md:px-10 lg:px-20">
              <div className="max-w-3xl">
                <div className="mb-3">
                  <Breadcrumb
                    items={[
                      { label: "首页", href: "/" },
                      { label: "关于我们" },
                    ]}
                  />
                </div>
                <h1 className="text-3xl md:text-5xl font-black font-heading text-background-50 mb-2">
                  关于我们
                </h1>
                <p className="text-sm md:text-base text-background-50/70 max-w-xl">
                  全网最活跃的免费吃瓜社区，用心做好每一个爆料
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20" style={{ backgroundColor: "oklch(0.97 0.02 75)" }}>
          <div className="max-w-5xl mx-auto px-4 md:px-6">
            <div className="grid grid-cols-1 lg:grid-cols-5 gap-10">
              <div className="lg:col-span-2">
                <span className="text-xs font-medium text-foreground-400 tracking-wider">Brand Story</span>
                <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mt-2 mb-4">
                  品牌故事
                </h2>
              </div>
              <div className="lg:col-span-3">
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                  51吃瓜爆料网创立于2020年，从一开始就确立了「让吃瓜变得更简单」的使命。我们深知在信息爆炸的时代，用户需要的不仅仅是最快的消息，更是最真实、最深入的报道。
                </p>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                  经过六年多的发展，我们已经建立起覆盖网红黑料、明星翻车、热点事件、娱乐八卦、视频爆料、深度深扒六大品类的完整内容体系。每一篇独家爆料背后，都有专业调查团队的辛勤付出。
                </p>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                  我们始终坚持免费运营理念，让每一位用户都能平等地获取信息。未来，我们将继续扩大信源网络，提升内容品质，做全网最值得信赖的吃瓜平台。
                </p>
              </div>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-14">
              {stats.map((stat, idx) => (
                <div key={idx} className="text-center p-4">
                  <div className="text-3xl md:text-4xl font-black font-heading text-foreground-900 mb-1">
                    {stat.value}
                  </div>
                  <div className="text-xs text-foreground-400">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 bg-background-50">
          <div className="max-w-5xl mx-auto px-4 md:px-6">
            <div className="text-center mb-10">
              <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
                品牌口碑
              </h2>
              <p className="mt-2 text-foreground-500 text-sm">听听行业和用户对我们的评价</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="rounded-xl bg-background-100 p-6 text-center">
                <div className="w-14 h-14 mx-auto rounded-full bg-accent-100 flex items-center justify-center mb-4">
                  <i className="ri-shield-check-line text-2xl text-accent-600"></i>
                </div>
                <h3 className="text-base font-bold font-heading text-foreground-900 mb-2">信息真实可靠</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  所有爆料内容经过多渠道交叉验证，真实性高达99.7%，是业内公认最可信的吃瓜平台。
                </p>
              </div>

              <div className="rounded-xl bg-background-100 p-6 text-center">
                <div className="w-14 h-14 mx-auto rounded-full bg-primary-100 flex items-center justify-center mb-4">
                  <i className="ri-flashlight-line text-2xl text-primary-500"></i>
                </div>
                <h3 className="text-base font-bold font-heading text-foreground-900 mb-2">更新速度领先</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  7×24小时全天候追踪，重大事件平均首发时间领先行业30%以上，让你永远快人一步。
                </p>
              </div>

              <div className="rounded-xl bg-background-100 p-6 text-center">
                <div className="w-14 h-14 mx-auto rounded-full bg-secondary-100 flex items-center justify-center mb-4">
                  <i className="ri-user-heart-line text-2xl text-secondary-600"></i>
                </div>
                <h3 className="text-base font-bold font-heading text-foreground-900 mb-2">用户至上理念</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  始终坚持完全免费，永不向用户收费。用户满意度常年保持在95%以上，是吃瓜群众的首选平台。
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 bg-background-100">
          <div className="max-w-5xl mx-auto px-4 md:px-6">
            <div className="text-center mb-10">
              <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
                发展历程
              </h2>
              <p className="mt-2 text-foreground-500 text-sm">从零到百万用户的成长之路</p>
            </div>

            <div className="max-w-2xl mx-auto">
              <div className="relative">
                <div className="absolute left-4 top-0 bottom-0 w-px bg-accent-200"></div>
                <div className="flex flex-col gap-8">
                  {milestones.map((m, idx) => (
                    <div key={idx} className="flex items-start gap-6 relative">
                      <div className="relative z-10 w-8 h-8 rounded-full bg-accent-500 flex items-center justify-center flex-shrink-0 mt-0.5">
                        <span className="text-[10px] font-bold text-foreground-950">{m.year.slice(2)}</span>
                      </div>
                      <div className="pt-0.5">
                        <span className="text-xs font-bold text-accent-600">{m.year}年</span>
                        <p className="text-sm text-foreground-600 mt-1">{m.event}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 bg-background-50">
          <div className="max-w-5xl mx-auto px-4 md:px-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
              <div>
                <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-6">
                  联系我们
                </h2>
                <div className="flex flex-col gap-4">
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                      <i className="ri-mail-line text-primary-500"></i>
                    </div>
                    <div>
                      <h4 className="text-sm font-semibold text-foreground-900 mb-1">爆料投稿</h4>
                      <p className="text-sm text-foreground-500">tips@chigua51.com</p>
                      <p className="text-xs text-foreground-400 mt-1">24小时接收爆料线索，严格保护信源隐私</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0">
                      <i className="ri-briefcase-line text-accent-600"></i>
                    </div>
                    <div>
                      <h4 className="text-sm font-semibold text-foreground-900 mb-1">商务合作</h4>
                      <p className="text-sm text-foreground-500">biz@chigua51.com</p>
                      <p className="text-xs text-foreground-400 mt-1">广告投放、品牌合作、内容授权</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 rounded-full bg-secondary-100 flex items-center justify-center flex-shrink-0">
                      <i className="ri-map-pin-line text-secondary-600"></i>
                    </div>
                    <div>
                      <h4 className="text-sm font-semibold text-foreground-900 mb-1">公司地址</h4>
                      <p className="text-sm text-foreground-500">中国北京市朝阳区建国路88号</p>
                      <p className="text-xs text-foreground-400 mt-1">SOHO现代城A座12层</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex flex-col justify-center items-center">
                <div className="relative w-full max-w-sm rounded-2xl overflow-hidden" style={{ backgroundColor: "oklch(0.96 0.03 80)" }}>
                  <img
                    src="https://readdy.ai/api/search-image?query=Warm%20atmospheric%20modern%20office%20workspace%20with%20team%20collaboration%20scene%20soft%20natural%20lighting%20editorial%20photography%20warm%20tones%20clean%20aesthetic%20professional%20environment&width=600&height=800&seq=about-contact&orientation=portrait"
                    alt="51吃瓜爆料网团队"
                    className="w-full h-80 object-cover object-top"
                    title="51吃瓜爆料网 - 联系我们"
                  />
                  <div className="p-5">
                    <h3 className="text-base font-bold font-heading text-foreground-900 mb-2">加入51吃瓜爆料</h3>
                    <p className="text-xs text-foreground-500 mb-4">如果您有爆料线索或合作需求，欢迎随时联系我们</p>
                    <Link to="/" className="btn-dark text-xs cursor-pointer inline-flex">
                      返回首页 <i className="ri-arrow-right-line ml-1"></i>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}